var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "p",
        {
          staticClass: "main-text body-1",
          attrs: { tabindex: "-1" },
          on: {
            click: function ($event) {
              return _vm.$emit("open-pose-sequences")
            },
          },
        },
        [_vm._v(_vm._s(_vm.activeSequenceName))]
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: _vm.isSmallScreen,
            "hide-overlay": _vm.isSmallScreen,
            "max-width": "800",
          },
          model: {
            value: _vm.showListDialog,
            callback: function ($$v) {
              _vm.showListDialog = $$v
            },
            expression: "showListDialog",
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-container" },
            [
              _c(
                "div",
                { staticClass: "d-flex flex-row align-baseline" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-4",
                      attrs: {
                        color: "accent",
                        disabled: !_vm.hasChanges || _vm.isManagingSequence,
                        loading: _vm.isSavingChanges,
                        outlined: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("save-changes")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.day6Resource.save))]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-4",
                      attrs: {
                        color: "accent",
                        outlined: "",
                        disabled: _vm.isManagingSequence,
                      },
                      on: { click: _vm.onNewPoseSequence },
                    },
                    [_vm._v(_vm._s(_vm.dataBrowserResource.new))]
                  ),
                  _c("div", { staticClass: "flex-grow-1" }),
                  _vm.isSmallScreen
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ma-4",
                          attrs: { color: "accent", outlined: "" },
                          on: {
                            click: function ($event) {
                              _vm.showListDialog = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.commonResource.close))]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.listDialogMessage
                ? _c("p", { staticClass: "body-1 mb-0 pa-4" }, [
                    _vm._v(_vm._s(_vm.listDialogMessage)),
                  ])
                : _vm._e(),
              _c("virtual-list", {
                staticClass: "list-container",
                style: { height: _vm.listHeight + "px" },
                attrs: {
                  "data-key": "id",
                  "data-sources": _vm.itemData,
                  "data-component": _vm.ListItem,
                },
                on: {
                  "on-press-item": _vm.onItemPress,
                  "on-edit-item": _vm.onEditSequenceName,
                  "on-delete-item": _vm.onItemDelete,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "max-width": "600",
            fullscreen: _vm.isSmallScreen,
            "hide-overlay": _vm.isSmallScreen,
          },
          model: {
            value: _vm.showEditDialog,
            callback: function ($$v) {
              _vm.showEditDialog = $$v
            },
            expression: "showEditDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c("p", { staticClass: "pt-4 body-1" }, [
                    _vm._v(_vm._s(_vm.dataBrowserResource.updateName)),
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      color: "accent",
                      filled: "",
                      "single-line": "",
                      rules: _vm.editNameRules,
                      label: _vm.dataBrowserResource.name,
                    },
                    model: {
                      value: _vm.editingName,
                      callback: function ($$v) {
                        _vm.editingName = $$v
                      },
                      expression: "editingName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", color: "accent" },
                      on: {
                        click: function ($event) {
                          _vm.showEditDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.commonResource.cancel))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", color: "accent" },
                      on: { click: _vm.updateName },
                    },
                    [_vm._v(_vm._s(_vm.day6Resource.save))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("FullDialog", {
        ref: "fullDialog",
        on: { "dialog-action": _vm.onDialogAction },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }